import axios from 'axios';

const clientAxios = axios.create({
  baseURL: 'https://monitor-icf.campofresco.net:2104/api', 
  headers: {
    'Content-Type': 'application/json',
  }
});

clientAxios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default clientAxios;
